import { render, staticRenderFns } from "./PageFile.vue?vue&type=template&id=a7c57720"
import script from "./PageFile.vue?vue&type=script&lang=js"
export * from "./PageFile.vue?vue&type=script&lang=js"
import style0 from "./PageFile.vue?vue&type=style&index=0&id=a7c57720&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports